import React, { useMemo } from 'react'
import {
  useLabelCategories,
  useLabels,
} from 'src/pages/AccountSettings/AccountSettings.hooks'
import { groupLabelsByCategory } from 'src/components/Reusable/Labels/labelGroups'
import { FilterName, FilterParam } from '../FilterBar.types'
import { NONE_VALUE } from '../FilterBar.constants'
import { FilterDropdown } from './FilterDropdown'
import { DropdownItemType } from './FilterDropdown.constants'

export const LabelFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const { data, isLoading, error } = useLabels()
    const { data: categoriesData, isLoading: isCategoriesLoading } =
      useLabelCategories()
    // Labels under a heading for each category, as in the control pickers.
    const filterValues = useMemo<DropdownItemType[]>(
      () => [
        NONE_VALUE,
        ...groupLabelsByCategory(
          data?.getItemsList() ?? [],
          categoriesData?.getItemsList() ?? [],
        ).flatMap((group) => [
          ...(group.name
            ? [
                {
                  value: `label-group:${group.name}`,
                  label: group.name,
                  isGroupHeading: true,
                },
              ]
            : []),
          ...group.labels,
        ]),
      ],
      [data, categoriesData],
    )
    if (error) return <></>

    return (
      <FilterDropdown
        filterParam={FilterParam.LABEL}
        filterName={FilterName.LABEL}
        filterValues={filterValues}
        isLoading={!data || isLoading || isCategoriesLoading}
        isNested={isNested}
      />
    )
  },
)
